/*
 * @Author: your name
 * @Date: 2021-03-01 16:52:31
 * @LastEditTime: 2021-08-12 10:04:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\store\programEditing\satae.js
 */
const state = {
  ratio: 1,
  vdrWindowSize: null,
  vdrList: [],
  vdrIndex: 0,
  isSaveProgram: false,
  grids:[],
  // vdrChildIndex: 0,
};

export default state;